import { createContext, use, type ReactNode } from "react";
import {
  disabledAnalytics,
  type AnalyticsClient,
} from "@/lib/analytics/analytics-client";

/**
 * Defaults to the client that sends nothing, so a tree with no provider
 * reports nothing rather than failing to render: pages that report are
 * rendered in harnesses that know nothing of analytics, and none of them
 * should have to. Exported for `ErrorBoundary`, a class, which reaches
 * context through `static contextType` rather than a hook.
 */
export const AnalyticsContext =
  createContext<AnalyticsClient>(disabledAnalytics);

/**
 * The client is passed in rather than built here, so a test can hand the tree
 * a fake and the composition root stays the only place that knows which one is
 * real.
 */
export function AnalyticsProvider({
  client,
  children,
}: {
  client: AnalyticsClient;
  children: ReactNode;
}) {
  return <AnalyticsContext value={client}>{children}</AnalyticsContext>;
}

export function useAnalytics(): AnalyticsClient {
  return use(AnalyticsContext);
}
